import { Controller } from "@hotwired/stimulus"
import { Offcanvas } from "bootstrap"

export default class extends Controller {
  static targets = ["frame"]
  static values = { fieldId: String }

  connect() {
    this.open = this.open.bind(this)
    window.addEventListener("imagePicker:open", this.open)
  }

  disconnect() {
    window.removeEventListener("imagePicker:open", this.open)
  }

  open(event) {
    this.fieldIdValue = event.detail.fieldId
    const frame = this.frameTarget
    if (frame.src) {
      frame.reload()
    } else {
      frame.src = event.detail.pickerUrl
    }
    Offcanvas.getOrCreateInstance(this.element).show()
  }

  preventFocus(event) {
    event.preventDefault()
  }

  selectImage(event) {
    const { id, url } = event.currentTarget.dataset
    window.dispatchEvent(new CustomEvent("imagePicker:selected", {
      detail: { fieldId: this.fieldIdValue, id, url }
    }))
    Offcanvas.getInstance(this.element).hide()
  }

  async uploadImage(event) {
    event.preventDefault()
    const form = event.target
    const response = await fetch(form.action, {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content },
      body: new FormData(form)
    })
    const { url, id } = await response.json()
    window.dispatchEvent(new CustomEvent("imagePicker:selected", {
      detail: { fieldId: this.fieldIdValue, id: id.toString(), url }
    }))
    Offcanvas.getInstance(this.element).hide()
    this.frameTarget.reload()
    form.reset()
  }
}
